import { trigger, transition, style, animate } from '@angular/animations';
import {
  Component,
  AfterContentInit,
  ContentChild,
  ElementRef,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-funnel-create',
  templateUrl: './funnel-create.component.html',
  styleUrls: ['./funnel-create.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0s ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class FunnelCreateComponent implements OnInit, AfterContentInit {
  hasCustomTemplate = false;
  @ContentChild('customTemplate') public customTemplateRef: ElementRef;

  constructor() {}

  ngAfterContentInit() {
    this.hasCustomTemplate = !!this.customTemplateRef;
  }

  ngOnInit() {}
}
